"use client";

import { useState, useEffect } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("har-cookies");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("har-cookies", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p className="text-cream/70 text-xs leading-relaxed max-w-xl">
        We use cookies to enhance your experience. By continuing, you agree to our{" "}
        <a href="#" className="underline text-gold-light hover:text-gold transition-colors">
          Privacy Policy
        </a>
        .
      </p>
      <button
        onClick={accept}
        className="shrink-0 bg-gold text-white text-xs font-semibold px-5 py-2 rounded-full hover:bg-gold-light transition-colors"
      >
        Accept
      </button>
    </div>
  );
}